export type FeatureSupportStatus = "available" | "unavailable";

export type FeatureSupportValue = {
  status: FeatureSupportStatus;
  rawValue: string | null;
};

const AVAILABLE_VALUES = new Set(["available"]);

const UNAVAILABLE_VALUES = new Set(["not-available", "not_available"]);

export const parseFeatureSupportStatus = (rawValue?: string | null): FeatureSupportValue => {
  if (rawValue == null) {
    return {
      status: "available",
      rawValue: null,
    };
  }

  const normalizedValue = rawValue.trim();

  if (!normalizedValue) {
    return {
      status: "available",
      rawValue,
    };
  }

  if (UNAVAILABLE_VALUES.has(normalizedValue.toLowerCase())) {
    return {
      status: "unavailable",
      rawValue,
    };
  }

  if (AVAILABLE_VALUES.has(normalizedValue.toLowerCase())) {
    return {
      status: "available",
      rawValue,
    };
  }

  return {
    status: "available",
    rawValue,
  };
};
